/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  
const gridItems = document.querySelectorAll('#SectionColumns--template--17715963265124__section_multicolumn_fgAkqn .grid-item');

gridItems.forEach((gridItem) => {
  const headingElement = gridItem.querySelector('.column__heading');
  const innerElement = gridItem.querySelector('.column__inner');

  if (headingElement && innerElement) {
    headingElement.parentElement.removeChild(headingElement);  // Remove from current location
    innerElement.prepend(headingElement);  // Move it as the first child
  }
});


  /////////////////////////////////////////////////////////////////////////////////////////

  ////////////// 3-cards section
  // Split Text
const spanElements = document.querySelectorAll('#shopify-section-template--17715963265124__section_highlights_WiTP9e .highlights__item__content span');

spanElements.forEach(span => {
  const [headerText, bodyText] = span.textContent.split('#separator#');
  const header = document.createElement('p');
  header.className = 'highlight-header';
  header.textContent = headerText;
  const body = document.createElement('p');
  body.className = 'highlight-body';
  body.textContent = bodyText;
  span.textContent = '';
  span.appendChild(header);
  span.appendChild(body);
});


  
  // Featured Collections Buttons
function addBuyNowButtons(productItems) {

  productItems.forEach((item) => {
    const productInfo = item.querySelector('.product-information');
    const productLink = item.querySelector('.product-link');

    if (productInfo && productLink) {
      if (!productInfo.querySelector('.buy-btn')) {
        const buyButton = document.createElement('a');
        buyButton.innerText = 'Buy Now';
        buyButton.classList.add('buy-btn');
        buyButton.href = productLink.href;
        productInfo.appendChild(buyButton);
      }
    }
  });
}

const productItemsHome = document.querySelectorAll('.grid--mobile-slider .grid-item');
const productItemsCollections = document.querySelectorAll('.grid-outer .grid-item');

addBuyNowButtons(productItemsHome);
addBuyNowButtons(productItemsCollections);

  /////////////////////////////////////////////////////////////////////////////////////////
  
  // Z-Ingredients Sections
document.addEventListener('DOMContentLoaded', function() {
  
// Select elements
const productLinks = document.querySelectorAll('#TabCollections--template--17517547225254__section_tab_collections_V3tVg7 .product-item__image .product-link');
const productButton = document.querySelectorAll('#TabCollections--template--17517547225254__section_tab_collections_V3tVg7 .product-information .buy-btn');
const productLabels = document.querySelectorAll('.product-item__info .product-link');
const removePriceItems = document.querySelectorAll('.product-item__info');
const tabLinks = document.querySelectorAll('.tab-link');
const ssButtonLink = document.querySelector('#CustomCode--template--17517547225254__section_custom_code_X3k7Rd a');
const ssButtonLabel = document.querySelector('#CustomCode--template--17517547225254__section_custom_code_X3k7Rd span');

const slideshow1 = document.getElementById('shopify-section-template--17517547225254__ss_slideshow_7_QKi9kN');
const slideshow2 = document.getElementById('shopify-section-template--17517547225254__ss_slideshow_7_zd8CYq');

// Function to set attributes and add click listeners
function setLinkAttributes(links, callback) {
  links.forEach((link, index) => {
    const ssButton = link.classList.contains('buy-btn');
    console.log('kachow', ssButton);
    link.setAttribute('tabindex', '0');
    link.setAttribute('role', 'button');
    link.setAttribute('aria-label', index);
    link.setAttribute('aria-current', index === 0 ? 'true' : 'false');
    link.addEventListener('click', (event) => {
      if (ssButton == false) {
        event.preventDefault();
      }
      const product = productLabels[index];
      ssButtonLink.href = product.href;
      ssButtonLabel.textContent = 'Buy ' + product.querySelector('.product-item__title').innerText.match(/^[^\s]+(?:\s[^\s]+)?(?=\sfrom|$)/)[0];
        
      callback(index);
    });
  });
}

// "Clicks" the Pagination Button to navigate the Gallery
setLinkAttributes(productLinks, (index) => {
  document.querySelectorAll('.swiper-pagination-bullet')[index].click();
});
setLinkAttributes(productButton, (index) => {
  document.querySelectorAll('.swiper-pagination-bullet')[index].click();
});

// Function to update buy button text with product title
function updateBuyButtonText() {
  productLabels.forEach((link, index) => {
    const productTitle = link.querySelector('.product-item__title').innerText.match(/^[^\s]+(?:\s[^\s]+)?(?=\sfrom|$)/)[0];
    if (productButton[index]) {
      productButton[index].textContent = productTitle;
    }
  });
}

// Function to handle tab changes
function handleTabChange(tab) {
  const selectedTab = tab.getAttribute('data-tab');
  if (selectedTab === '0') {
    slideshow1.style.display = 'block';
    slideshow2.style.display = 'none';
  } else if (selectedTab === '1') {
    slideshow1.style.display = 'none';
    slideshow2.style.display = 'block';
  }
  updateBuyButtonText(); // Update buy button text for the displayed slideshow
}

// Handle tab interactions (click and keyboard)
tabLinks.forEach((tab) => {
  tab.addEventListener('click', () => handleTabChange(tab));
  tab.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTabChange(tab);
    }
  });
});

// Hide price elements
removePriceItems.forEach(item => {
  item.style.display = 'none';
});

// Initial call to update buy button text and show the first slideshow by default
updateBuyButtonText();
slideshow1.style.display = 'block'; // Show first slideshow
slideshow2.style.display = 'none';  // Hide second slideshow

});

  //////////// Fix for upcart home page issue
 
  document.addEventListener('DOMContentLoaded', function() {
    const upcart = document.getElementById('upCart');
    
    const mainbody = document.getElementById('MainContent');

    if (upcart && mainbody) {
      mainbody.appendChild(upcart);
    
    } else {
      console.log('Either the element to move or the target parent was not found.');
    }

    
  });


  // Smaller ™ and ®
  document.querySelectorAll('.product__block .product__heading').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/®/, '<span class="trademark">®</span>');
  });
  document.querySelectorAll('.product__block .product__heading').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/™/, '<span class="trademark">™</span>');
  });

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
